import { useCounterAnimation } from '@/hooks/useScrollAnimation';

/**
 * Komponen animated counter untuk angka statistik
 * Menghitung dari 0 sampai target number dengan animasi smooth
 */
export default function AnimatedCounter({ 
  end, 
  duration = 2000, 
  suffix = '',
  prefix = '',
  className = ''
}) {
  const [ref, displayValue] = useCounterAnimation(end, duration, { suffix, prefix });

  return (
    <span ref={ref} className={className}>
      {displayValue}
    </span>
  );
}
